module.exports = __webpack_public_path__ + "static/media/T8.be97c0ac.jpg";